/* import __COLOCATED_TEMPLATE__ from './footer.hbs'; */
import type { Dropdown } from 'ember-basic-dropdown/components/basic-dropdown';

import templateOnlyComponent from '@ember/component/template-only';

export interface BvPopoverFooterSignature {
  Args: {
    popover?: Dropdown;
  };
  Blocks: {
    default: [popover?: Dropdown];
  };
  Element: HTMLElement;
}

const BvPopoverFooterComponent = templateOnlyComponent<BvPopoverFooterSignature>();

export default BvPopoverFooterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvPopover::Footer': typeof BvPopoverFooterComponent;
    'bv-popover/footer': typeof BvPopoverFooterComponent;
  }
}
